import LeaveLog from "./LeaveLog.vue";
export default LeaveLog;
